import { Provider } from 'interfaces';
import { http, HttpResponse } from 'msw';
import { buildProvider } from '../../factories';
import { canonicalProviders } from '../../factories/seeds/entities';
import { mockSites } from './siteMock';
const siteByID = new Map(mockSites.map((site) => [site.id, site]));

export const mockProviders: Provider[] = canonicalProviders.map(
  (provider) =>
    buildProvider<Provider>({
      ...provider,
      sites: provider.sites
        .map((site) => siteByID.get(site.id))
        .filter((site): site is (typeof mockSites)[number] => Boolean(site)),
      user: null,
    }) as Provider
);

export const testProvider: Provider = buildProvider<Provider>({
  ...mockProviders[2],
  license: '00000',
  email: '',
}) as Provider;

export const mockProviderHandlers = [
  http.get('*/resource/provider/site', () => {
    return HttpResponse.json(mockProviders);
  }),
  http.get('*/resource/provider/organization', () => {
    return HttpResponse.json(mockProviders);
  }),
  http.get('*/resource/provider/all', () => {
    return HttpResponse.json(mockProviders);
  }),
  http.get('*/resource/provider/favourite/diagnosis', () => {
    return HttpResponse.json([]);
  }),
  http.post('*/resource/provider', async ({ request }) => {
    const response = await request.json();
    return HttpResponse.json(response);
  }),
  http.post('*/resource/provider/bulk', () => {
    return HttpResponse.json({
      jobId: '11111111-1111-4111-8111-111111111111',
      status: 'COMPLETED',
      bucket: 'provider-files-test',
      providerKey: 'providers.txt',
    });
  }),
  http.get('*/resource/provider/bulk', () => {
    return HttpResponse.json({
      jobId: '11111111-1111-4111-8111-111111111111',
      status: 'COMPLETED',
      bucket: 'provider-files-test',
      providerKey: 'providers.txt',
      result: {
        success: true,
        totalRows: 0,
        createdCount: 0,
        skippedCount: 0,
        failedCount: 0,
        created: [],
        skipped: [],
        failed: [],
      },
    });
  }),
  http.put('*/resource/provider', async ({ request }) => {
    const response = await request.json();
    return HttpResponse.json(response);
  }),
  http.put('*/resource/provider/add', async ({ request }) => {
    const response = await request.json();
    return HttpResponse.json(response);
  }),
  http.post('*/resource/provider/link', async ({ request }) => {
    const response = await request.json();
    return HttpResponse.json(response);
  }),
  http.post('*/resource/provider/favourite/diagnosis', async ({ request }) => {
    const response = await request.json();
    return HttpResponse.json(response);
  }),
];
